import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles({
  unit: {
    display: 'flex'
  },
  noEmail: {
    color: palette.shades[700]
  }
});
export default useStyles;